import createReactComponent from '../createReactComponent';
export default createReactComponent('currency-rufiyaa', 'IconCurrencyRufiyaa', [
  ['path', { d: 'M20 16h.01', key: 'svg-0' }],
  ['path', { d: 'M4 16c9.5 -4 11.5 -8 14 -9', key: 'svg-1' }],
  ['path', { d: 'M12 8l5 3', key: 'svg-2' }],
]);
